var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.event.items),function(item,index){return _c('Cell',{key:index,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }